import React from 'react';
import { Fab, Badge } from '@mui/material';
import { NoteAlt as NotepadIcon } from '@mui/icons-material';
import { useMedicationCart } from '../../contexts/MedicationCartContext';

interface CartFabProps {
  onClick: () => void;
}

export const CartFab: React.FC<CartFabProps> = ({ onClick }) => {
  const { itemCount } = useMedicationCart();

  if (itemCount === 0) return null;

  return (
    <Fab
      onClick={onClick}
      sx={{
        position: 'fixed',
        bottom: { xs: 'calc(72px + env(safe-area-inset-bottom))', md: 24 },
        right: 16,
        background: '#0066CC',
        color: '#fff',
        boxShadow: '0 4px 12px rgba(0,102,204,0.35)',
        zIndex: (theme) => theme.zIndex.appBar + 1,
        '&:hover': { background: '#004C99' },
      }}
    >
      <Badge
        badgeContent={itemCount}
        color="error"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: 12,
            fontWeight: 700,
            minWidth: 22,
            height: 22,
          },
        }}
      >
        <NotepadIcon />
      </Badge>
    </Fab>
  );
};
